const passpharse = /^((([a-zA-Z0-9!"#$%&'()*+,.\\/:;<=>?@\\[\]\\^_`{|}~-]|[ ]){8,63})|([0-9a-fA-F]{64}))$/;
const passpharseWpa3 = /^((([a-zA-Z0-9!"#$%&'()*+,.\\/:;<=>?@\\[\]\\^_`{|}~-]|[ ]){8,127})|([0-9a-fA-F]{128}))$/;
const radiusSecret = /^([a-zA-Z0-9!"#$%&'()*+,.\\/:;<=>?@\\[\]\\^_`{|}~-]|[ ]){1,128}$/;
const ssid = /^(([a-zA-Z0-9!"#$%&'()*+,.\\/:;<=>?@\\[\]\\^_`{|}~-]|[ ]){1,32})$/;
const ipv4 = /^(([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-5])[.]){3}([0-9]|[1-9][0-9]|1[0-9][0-9]|2[0-4][0-9]|25[0-4])$/;
const ipv6 = /^((([0-9A-Fa-f]{1,4}:){7}([0-9A-Fa-f]{1,4}|:))|(([0-9A-Fa-f]{1,4}:){6}(:[0-9A-Fa-f]{1,4}|((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){5}(((:[0-9A-Fa-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){4}(((:[0-9A-Fa-f]{1,4}){1,3})|((:[0-9A-Fa-f]{1,4})?:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){3}(((:[0-9A-Fa-f]{1,4}){1,4})|((:[0-9A-Fa-f]{1,4}){0,2}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){2}(((:[0-9A-Fa-f]{1,4}){1,5})|((:[0-9A-Fa-f]{1,4}){0,3}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){1}(((:[0-9A-Fa-f]{1,4}){1,6})|((:[0-9A-Fa-f]{1,4}){0,4}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(:(((:[0-9A-Fa-f]{1,4}){1,7})|((:[0-9A-Fa-f]{1,4}){0,5}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))$/;
const netmask1 = /((128|192|224|240|248|252|254)[.]0[.]0[.]0)|(255[.](0|128|192|224|240|248|252|254)[.]0[.]0)|(255[.]255[.](0|128|192|224|240|248|252|254)[.]0)|(255[.]255[.]255[.](0|128|192|224|240|248|252|254|255))/;
/** netmask2: not support 255.255.255.255 **/
const netmask2 = /((128|192|224|240|248|252|254)[.]0[.]0[.]0)|(255[.](0|128|192|224|240|248|252|254)[.]0[.]0)|(255[.]255[.](0|128|192|224|240|248|252|254)[.]0)|(255[.]255[.]255[.](0|128|192|224|240|248|252|254))/;
const domain = /^((([a-zA-Z0-9_]([a-zA-Z0-9\\-_]){0,61})?[a-zA-Z0-9][.])*([a-zA-Z0-9_]([a-zA-Z0-9\\-_]){0,61})?[a-zA-Z0-9])$/;
const serverDomain = /(?=^.{1,255}$)(^[a-zA-Z]([-a-zA-Z0-9]{0,61}[a-zA-Z0-9])?(\.[a-zA-Z]([-a-zA-Z0-9]{0,61}[a-zA-Z0-9])?)*$)/;
const aftrDomain = /^(www\.)?[-a-zA-Z0-9]+(\.[-a-zA-Z0-9]+)+$/;
const internetDomain = /(?=^.{1,255}$)(^[a-zA-Z]([-a-zA-Z0-9]{0,61}[a-zA-Z0-9])?(\.[a-zA-Z]([-a-zA-Z0-9]{0,61}[a-zA-Z0-9])?)*$)/;
const deviceName = /^[a-zA-Z][a-zA-Z0-9-_]{0,14}$/;
const DdnsHost = /^[a-zA-Z0-9-.]{1,255}$/;
const DdnsOrayUserName = /^[a-zA-Z0-9-_]{1,16}$/;
const mac = /([a-fA-F0-9]{2}:){5}([a-fA-F0-9]{2})/;
const ipv4OrDomain = [ipv4, domain];
const pptpUsername = /^([a-zA-Z0-9!"#$%&'()*+,.\\/:;<=>?@\\[\]\\^_`{|}~-]){1,60}$/;
const pptpPassword = /^([a-zA-Z0-9!"#$%&'()*+,.\\/:;<=>?@\\[\]\\^_`{|}~-]){0,50}$/;
const l2tpPassword = /^([a-zA-Z0-9!"#$%&'()*+,.\\/:;<=>?@\\[\]\\^_`{|}~-]){0,60}$/;
const pppoeUsername = /^([a-zA-Z0-9!"#$%&'()*+,.\\/:;<=>?@\\[\]\\^_`{|}~-]){1,64}$/;
const pppoePassword = /^([a-zA-Z0-9!"#$%&'()*+,.\\/:;<=>?@\\[\]\\^_`{|}~-]){0,64}$/;
const connectionId = /([a-zA-Z0-9!"#$%&'()*+,.\\/:;<=>?@\\[\]\\^_`{|}~-]|[ ]){0,63}/;
const pppoeServerName = /^([a-zA-Z0-9!"#$%&'()*+,.\\/:;<=>?@\\[\]\\^_`{|}~-]){0,50}$/;
const modelName = /([a-zA-Z0-9!"#$%&'()*+,.\\/:;<=>?@\\[\]\\^_`{|}~-]|[ ]){1,30}/;
const printableAndSpace = /^([a-zA-Z0-9!"#$%&'()*+,.\\/:;<=>?@\\[\]\\^_`{|}~-]|[ ]){1,322}$/;
const printable = /^([a-zA-Z0-9!"#$%&'()*+,.\\/:;<=>?@\\[\]\\^_`{|}~-])*$/;
const port = /^(([0-9]|[1-9]\d{1,3}|[1-5]\d{4}|6[0-4]\d{3}|65[0-4]\d{2}|655[0-2]\d|6553[0-5]})|(([ ]|[0-9]|[1-9]\d{1,3}|[1-5]\d{4}|6[0-4]\d{3}|65[0-4]\d{2}|655[0-2]\d|6553[0-5]})+([,]|[-]|([ ]|[0-9]|[1-9]\d{1,3}|[1-5]\d{4}|6[0-4]\d{3}|65[0-4]\d{2}|655[0-2]\d|6553[0-5]}))))*$/;
const number = /^[\d]+$/;
const emailAddr = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
const interfaceId = /([a-fA-F0-9]:{0,4}){2}([a-fA-F0-9]{0,4})/;
const ipv6Address = /([a-fA-F0-9])/;
const ipv6Domain = /(?=^.{1,255}$)(^[a-zA-Z0-9]([-a-zA-Z0-9]{0,61}[a-zA-Z0-9])?(\.[a-zA-Z]([-a-zA-Z0-9]{0,61}[a-zA-Z0-9])?)*$)/;
module.exports = {
  ssid,
  passpharse,
  passpharseWpa3,
  radiusSecret,
  ipv4,
  ipv6,
  domain,
  serverDomain,
  aftrDomain,
  netmask1,
  netmask2, // not support 255.255.255.255
  deviceName,
  DdnsHost,
  DdnsOrayUserName,
  internetDomain,
  mac,
  ipv4OrDomain,
  pptpUsername,
  pptpPassword,
  l2tpUsername: pptpUsername,
  l2tpPassword,
  pppoeUsername,
  pppoePassword,
  connectionId,
  pppoeServerName,
  orange_france_pppoeUsername: pppoeUsername,
  orange_france_pppoePassword: pppoePassword,
  orange_france_dhcpUsername: pppoeUsername,
  movistar_spain_pppoeUsername: pppoeUsername,
  movistar_spain_pppoePassword: pppoePassword,
  vodafone_spain_pppoeUsername: pppoeUsername,
  vodafone_spain_pppoePassword: pppoePassword,
  modelName,
  printableAndSpace,
  printable,
  number,
  emailAddr,
  interfaceId,
  ipv6Domain,
  ipv6Address,
  port,
};
